<template>
    <div class="header">
        <!-- 折叠按钮 -->
        <div>
            <div class="collapse-btn" @click="collapseChage">
                <img :src="groupPic" class="wr_logo" v-if="groupPic!=null && groupPic != '' && groupPic != 'null'"/>
                <!-- <img src="../../assets/main/minzheng.png" class="mz_logo" v-else/> -->
                <img src="../../assets/main/white_logo.png" class="white_logo" v-else/>
                <!-- <img src="../../assets/main/wanrong_logo.png" class="wr_logo"/> -->
            </div>
            <div class="logo" v-if="!collapse">智慧养老</div>
        </div>
        <div class="header-right">
            <div class="header-user-con">
                <!-- 全屏显示 -->
                <!-- <div class="btn-fullscreen" @click="handleFullScreen">
                    <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
                        <i class="el-icon-rank"></i>
                    </el-tooltip>
                </div> -->
                <el-popover
                  placement="right"
                  width="800"
                  v-if="groupId==1034"
                  trigger="click">
                  <el-table :data="gridData" >
                    <el-table-column width="280" property="title" label="提醒时间"></el-table-column>
                    <el-table-column width="430" property="content" label="提醒内容"></el-table-column>
                    <el-table-column width="90" property="status" label="操作">
                        <template slot-scope="scope">
                           <el-button type="primary" v-if="scope.row.status!=1" plain @click="readItem(scope.row)">确认</el-button>
                         </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                     background
                     @current-change="handleCurrentChange"
                     :current-page="notifyPage"
                     layout="total, prev, pager, next"
                     :total="reminderNum"
                     align="center">
                 </el-pagination>  
                  <el-badge slot="reference" :value="reminderNum" :max="999" class="item_click">
                    <i class="el-icon-chat-dot-round" style="font-size:36px"></i>
                  </el-badge>
                </el-popover>


                <el-badge  :value="alertNum" :max="999" @click.native.stop="jumpAlert" class="item_click" style="margin-left:10px">
                    <i class="el-icon-bell" style="font-size:36px"></i>
                </el-badge>
                <!-- 用户头像 -->
                <div class="user-avator">
                    <img src="../../assets/main/user.png" /> 
                </div>
                <!-- 用户名下拉菜单 -->
                <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        <span class="el-dropdown-link">{{username}}</span>
                        <i class="el-icon-caret-bottom"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="showBig">可视化大屏</el-dropdown-item>
                        <el-dropdown-item command="showFull" v-if="!isBig">全屏展示</el-dropdown-item>
                        <el-dropdown-item command="showSmall" v-if="isBig">取消全屏</el-dropdown-item>
                        <el-dropdown-item command="loginout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>
<script>
import bus from "@/vuex/eventBus";
import { baseURL } from "@/utils/request.js";
export default {
    data() {
        return {
            collapse: false,
            fullscreen: false,
            username: 'user',
            groupPic: null,
            ptFlag: 0,// 0 乐活 1 万融 2 中职
            alertNum:0,
            groupId: sessionStorage.getItem("groupId"),
            reminderNum:0,
            notifyPage: 1,
            isBig:false,
            gridData:[],
        };
    },
    methods: {
        jumpAlert(){
           bus.$emit("homePage", {
            type: "jump",
            path: "/alarmlog",
            title: "告警记录",
          });
        },
        readItem(row){
            this.$postForm("omc/notification/read/"+row.id, {
            }).then(res=>{
                this.$message({ message: res.message, type: "success" });
                this.fetchNotification();
            })
        },
        handleCurrentChange(val){
            console.log(val);
            this.notifyPage = val;
            this.fetchNotification();
        },
        jumpReminder(){
            // 弹窗展示提醒；

        },
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == 'showFull'){
                this.isBig = true;
                let element = document.documentElement;
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                }
            } if (command == 'showSmall'){
                this.isBig = false;
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            }  else if (command == 'loginout') {
                localStorage.removeItem('ms_username');
                localStorage.removeItem("token");
                sessionStorage.removeItem("user");
                this.$router.push('/login');
            }else if(command == 'showBig'){
                this.$router.push('/bigView');
            }
        },
        // 侧边栏折叠
        collapseChage() {
            this.collapse = !this.collapse;
            bus.$emit('collapse', this.collapse);
        },
        fetchNotification(){
            this.$postJson("omc/notification/list", {
                status:"UNREAD",
                pageNum: this.notifyPage,
                pageSize: 10
            }).then(res=>{
                console.log(res.result);
                this.reminderNum = Number(res.result.total);
                this.gridData = res.result.list;
            })
        },
        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        }
    },
    mounted() {
        if (document.body.clientWidth < 1200) {
            this.collapseChage();
        }
    },
    created() {
        //omc/notification/list
        if(this.groupId == 1034){
            this.fetchNotification();
        }

        if(sessionStorage.getItem("uerName")!=null){
            this.username = sessionStorage.getItem("uerName")
        }
        if(localStorage.getItem("groupPic")!=null && localStorage.getItem("groupPic")!=""){
            this.groupPic = localStorage.getItem("groupPic");
        }
        bus.$on("uerName", (msg) => {
            this.username = msg;
        });
        bus.$on("alertNumber",(num) =>{
            this.alertNum = num;
        });
    }
};
</script>
<style scoped>
.item_click{
    cursor: pointer;
}
.header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 64px;
    font-size: 22px;
    color: #fff;
}
.white_logo{
    width: 54px;
    height: 38px;
    margin: 0 10px;
    margin-top: 17px;
    margin-left: 10px;
    caret-color: rgba(0, 0, 0, 0);
}
.mz_logo{
    width: 54px;
    height: 54px;
    margin: 0 10px;
    margin-top: 10px;
    margin-left: 5px;
    caret-color: rgba(0, 0, 0, 0);
}
.wr_logo{
    width: 58px;
    height: 54px;
    margin: 0 10px;
    margin-top: 10px;
    margin-left: 5px;
    caret-color: rgba(0, 0, 0, 0);
}
.zz_logo{
    width: 54px;
    height: 54px;
    margin: 0 10px;
    margin-top: 5px;
    margin-left: 5px;
    caret-color: rgba(0, 0, 0, 0);
}
.collapse-btn {
    float: left;
    cursor: pointer;
    line-height: 60px;
    height: 60px;
    background: #1395DB;
}
.logo {
    float: left;
    width: 100px;
    font-size: 24px;
    line-height: 52px;
    margin-top: 10px;
}
.wr_logo_tx {
    float: left;
    width: 100px;
    font-size: 18px;
    margin-left: 6px;
    margin-top: 12px;
}

.zxlogo {
    float: left;
    width: 100px;
    font-size: 24px;
    line-height: 26px;
    margin-top: 10px;
}

.log_title {
    vertical-align: middle;
    font-size: 22px;
    color: white;
    width: 100px;
    line-height: 20px;
    display: inline-block;
    margin-left: 10px;
}
  
.logo_smtxt {
    font-size: 12px;
    padding-left: 5px;
}
  
.header-right {
    float: right;
    padding-right: 10px;
}
.header-user-con {
    display: flex;
    height: 70px;
    align-items: center;
}
.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
}
.btn-bell,
.btn-fullscreen {
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
}
.btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
}
.btn-bell .el-icon-bell {
    color: #fff;
}
.user-name {
    margin-left: 5px;
}
.user-avator {
    margin-left: 25px;
}
.user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}
.el-dropdown-link {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
}
.el-dropdown-menu__item {
    text-align: center;
}
</style>
